import { dom, library } from '@fortawesome/fontawesome-svg-core'
import { faCamera } from '@fortawesome/pro-solid-svg-icons'
import { faTachometer } from '@fortawesome/pro-solid-svg-icons'
import { faClipboardListCheck } from '@fortawesome/pro-solid-svg-icons'

library.add(faTachometer);
library.add(faCamera);
library.add(faClipboardListCheck);
dom.watch()